import React from 'react';
import AppRouter from './routes';

import HomePage from './pages/HomePage';

function App() {
  return (
    <div className="App">
      <AppRouter />
    </div>
  );
}

export default App;
